import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { RequestService } from 'src/app/core/services/request.service';
import { UrlService } from 'src/app/core/services/url.service';
import { IUser } from '../auth/user';
import { AbstractService } from '../util/abstract.service';
import { Url } from '../util/url.class';
import { NavBarItem } from './navbar-item.class';

@Injectable({
  providedIn: 'root'
})
export class NavbarService extends AbstractService {
  public admin?: boolean;
  private _menu: NavBarItem[];
  //This is for the admin panel eka commented
  public isErp = true;
  public hide = false;

  urlService: UrlService;
  requestService: RequestService;

  get menu(): NavBarItem[] {
    return this._menu;
  }
  set menu(value: NavBarItem[]) {
    this._menu = value;
  }

  constructor(injector: Injector) {
    super(injector);
    this.urlService = injector.get(UrlService);
    this.requestService = injector.get(RequestService);
  }
  public loadNavbar(user: IUser) {
    const url: Url = this.urlService.baseAppUrl;
    url.path.push('client-navbar-items');

    this.requestService
      .get(url.serialize())
      .pipe(
        map((data: any) => {
          const menu: NavBarItem[] = data.payload;
          if (user.allowedModules?.bi) {
            this.addBiItem(menu);
          }
          this.menu = menu;
        })
      )
      .subscribe();
  }

  private addBiItem(menu: NavBarItem[]) {
    const biItem: NavBarItem = {
      label: 'shared.menu.bi',
      icon: null,
      route: {
        url: '/brew/bi',
        isAngularRoute: false,
        isEntitled: true
      }
    };

    // Place BI before the external "Lab" link, which always stays last
    const labIndex = menu.findIndex((item) => item.label === 'shared.menu.lab');
    menu.splice(labIndex === -1 ? menu.length : labIndex, 0, biItem);
  }

  updateDesignModeForUser(designMode: any, clb: (e: any) => any, error?: (e: any) => any, complete?: () => any) {
    const url: Url = this.urlService.baseAppUrl;
    url.push('switch-design-mode');
    url.put('designMode', designMode);
    this._subscribe(this.requestService.get(url.serialize()), clb, error, complete);
  }
}
